import Lenis from 'lenis';
import { reduceMotion } from './env';

/*
  Défilement doux (Lenis) et liens d'ancre.

  L'option `anchors` de Lenis n'annule pas le clic : le navigateur suivrait
  aussi l'ancre (avec `scroll-behavior: smooth` sur html) et les deux
  défilements se battraient. On gère donc nous-mêmes les liens `#…` et `/#…`
  qui pointent vers la page courante.
*/

export let lenis: Lenis | undefined;

if (!reduceMotion) {
  lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
  const raf = (time: number) => {
    lenis?.raf(time);
    requestAnimationFrame(raf);
  };
  requestAnimationFrame(raf);
}

/** Cible d'un hash (`#about`), ou null si absente / invalide. */
export function hashTarget(hash: string): HTMLElement | null {
  if (!hash) return null;
  try {
    return document.querySelector<HTMLElement>(`#${CSS.escape(decodeURIComponent(hash.slice(1)))}`);
  } catch {
    return null;
  }
}

/** Le lien pointe-t-il vers une ancre de la page courante ? */
export function isSamePageAnchor(url: URL): boolean {
  return (
    url.origin === location.origin &&
    url.pathname === location.pathname &&
    url.search === location.search &&
    url.hash !== ''
  );
}

document.addEventListener('click', (event) => {
  if (!lenis || event.defaultPrevented || event.button !== 0) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = (event.target as Element | null)?.closest?.<HTMLAnchorElement>('a[href]');
  if (!link || link.closest('[data-contact-open]') || (link.target && link.target !== '_self'))
    return;

  const url = new URL(link.href, location.href);
  if (!isSamePageAnchor(url)) return;

  // `#top` : haut de page
  const target = url.hash === '#top' ? 0 : hashTarget(url.hash);
  if (target === null) return;
  event.preventDefault();
  lenis.scrollTo(target);
  if (url.hash !== location.hash) history.pushState(history.state, '', url.hash);
});

/**
 * Arrivée sur une page avec un hash (depuis une autre page) : se placer sur la
 * cible, immédiatement (le rideau couvre encore l'écran).
 */
export function scrollToInitialHash() {
  const target = hashTarget(location.hash);
  if (!target || !lenis) return;
  lenis.resize();
  lenis.scrollTo(target, { immediate: true, force: true });
}
